import { Component } from '@angular/core';
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'spinner',
    templateUrl: './spinner.component.html',
    standalone: false
})
export class SpinnerComponent {
    constructor(public utilService: UtilService) {
    }
}
